<template>
  <div class="part-item projectSchema">
    <p class="part-title">系统架构图及简要说明
    </p>
    <div class="part-content">
      <span class="content-title">简要说明：</span>
      <div
        class="content-text"
        v-if="!formInfo.frame_content"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.frame_content"
        v-html="formInfo.frame_content"
      ></div>
      <div class="clearfix"></div>
      <div class="content-text"></div>
      <div class="content-text">
        <ul id="schemaPics">
          <li
            v-for="(item, index) in infoFrameFileList"
            :key="index"
          ><img
              :src="item.src"
              :alt="item.name"
            ></li>
        </ul>
      </div>
    </div>
    <p class="part-title">实验教学
    </p>
    <div class="part-content">
      <span class="content-title">开发技术：</span>
      <div class="content-text">
        {{ infoExperimentTech.tech.v1 ? 'VR，' : '' }}
        {{ infoExperimentTech.tech.v2 ? 'AR，' : '' }}
        {{ infoExperimentTech.tech.v3 ? 'MR，' : '' }}
        {{ infoExperimentTech.tech.v4 ? '3D仿真，' : '' }}
        {{ infoExperimentTech.tech.v5 ? '二维动画，' : '' }}
        {{ infoExperimentTech.tech.v6 ? 'HTML5，' : '' }}
        {{ infoExperimentTech.tech.v7 ? '其他：' : '' }}
        <span
          class="otherTech_content"
          v-if="infoExperimentTech.tech.v7"
        >{{ infoExperimentTech.tech.otherText }}</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">开发工具：</span>
      <div class="content-text">
        {{ infoExperimentTech.tool.v1 ? 'Unity3D，' : '' }}
        {{ infoExperimentTech.tool.v2 ? '3D Studio Max，' : '' }}
        {{ infoExperimentTech.tool.v3 ? 'Maya，' : '' }}
        {{ infoExperimentTech.tool.v4 ? 'ZBrush，' : '' }}
        {{ infoExperimentTech.tool.v5 ? 'SketchUp，' : '' }}
        {{ infoExperimentTech.tool.v6 ? 'Adobe Flash，' : '' }}
        {{ infoExperimentTech.tool.v7 ? 'Unreal Development Kit，' : '' }}
        {{ infoExperimentTech.tool.v8 ? 'Animate CC，' : '' }}
        {{ infoExperimentTech.tool.v9 ? 'Blender，' : '' }}
        {{ infoExperimentTech.tool.v10 ? 'Visual Studio，' : '' }}
        {{ infoExperimentTech.tool.v11 ? '其他' : '' }}
        <span
          v-if="infoExperimentTech.tool.v11"
          class="otherTool_content"
        >{{ infoExperimentTech.tool.otherText }}</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">运行环境：</span>
      <div class="content-text">
        <h3>服务器</h3>
        CPU<span class="underline_txt">{{ infoExperimentTech.env.server.cpu }}</span>核、
        内存<span class="underline_txt">{{ infoExperimentTech.env.server.mem }}</span>GB、
        磁盘<span class="underline_txt">{{ infoExperimentTech.env.server.disk }}</span>GB、
        显存<span class="underline_txt">{{ infoExperimentTech.env.server.gpu_size }}</span>GB、
        GPU型号<span class="underline_txt">{{ infoExperimentTech.env.server.gpu_no }}</span>
        <h3>操作系统</h3>
        {{ infoExperimentTech.env.sys.window_server ? 'Windows Server，' : '' }}
        {{ infoExperimentTech.env.sys.window_server ? '具体版本：' : ''  }}
        <span
          v-if="infoExperimentTech.env.sys.window_server"
          class="underline_txt"
        >{{ infoExperimentTech.env.sys.window_server_v }}</span>
        <br v-if="infoExperimentTech.env.sys.window_server">
        {{ infoExperimentTech.env.sys.linux ? 'Linux，' : '' }}
        {{ infoExperimentTech.env.sys.linux ? '具体版本：' : ''  }}
        <span
          v-if="infoExperimentTech.env.sys.linux"
          class="underline_txt"
        >{{ infoExperimentTech.env.sys.linux_v }}</span>
        <br v-if="infoExperimentTech.env.sys.linux">
        {{ infoExperimentTech.env.sys.other ? infoExperimentTech.env.sys.other_name : '' }}
        {{ infoExperimentTech.env.sys.other ? '具体版本：' : ''  }}
        <span
          v-if="infoExperimentTech.env.sys.other"
          class="underline_txt"
        >{{ infoExperimentTech.env.sys.other_version }}</span>
        <h3>数据库</h3>
        {{ infoExperimentTech.env.db.v1 ? 'Mysql，' : ''}}
        {{ infoExperimentTech.env.db.v2 ? 'SQL Server，' : ''}}
        {{ infoExperimentTech.env.db.v3 ? 'Oracle，' : ''}}
        {{ infoExperimentTech.env.db.v4 ? '其他' : ''}}
        <span
          v-if="infoExperimentTech.env.db.v4"
          class="otherBase_content"
        >{{ infoExperimentTech.env.db.otherText }}</span>
        <br>
        备注说明
        <span class="underline_txt">{{ infoExperimentTech.env.db.des }}</span>
        <br>
        是否支持云渲染：
        <span
          v-if="infoExperimentTech.cloud_support == 1"
          class="underline_txt"
        >是</span>
        <span
          v-if="infoExperimentTech.cloud_support == 0"
          class="underline_txt"
        >否</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">实验品质：</span>
      <div class="content-text">
        单场景模型总面数<span class="underline_txt">{{ infoExperimentTech.quality.situation_count }}</span>个
        <br>
        贴图分辨率<span class="underline_txt">{{ infoExperimentTech.quality.pic_x }}</span>px
        *<span class="underline_txt">{{ infoExperimentTech.quality.pic_y }}</span>px
        <br>
        每帧渲染次数<span class="underline_txt">{{ infoExperimentTech.quality.times }}</span>calls
        <br>
        动作反馈时间<span class="underline_txt">{{ infoExperimentTech.quality.action_time }}</span>ms
        <br>
        显示刷新率<span class="underline_txt">{{ infoExperimentTech.quality.refresh }}</span>FPS
        <br>
        分辨率<span class="underline_txt">{{ infoExperimentTech.quality.x }}</span>ppi
        *<span class="underline_txt">{{ infoExperimentTech.quality.y }}</span>ppi
        <br>
        其他<span class="underline_txt">{{ infoExperimentTech.quality.other }}</span>
        <br>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'TechnicalFrame',
  props: ['expId'],
  components: {
  },
  data () {
    return {
      formInfo: {
        frame_content: '',
        frame_file: '',
        frame_experiment_tech: ''
      },

      infoFrameFileList: [],

      infoExperimentTech: {
        tech: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          otherText: ''
        },
        tool: {
          v1: false,
          v2: false,
          v3: false,
          v4: false,
          v5: false,
          v6: false,
          v7: false,
          v8: false,
          v9: false,
          v10: false,
          v11: false,
          otherText: ''
        },
        env: {
          server: {
            cpu: '',
            mem: '',
            disk: '',
            gpu_size: '',
            gpu_no: ''
          },
          sys: {
            window_server: false,
            window_server_v: '',
            linux: false,
            linux_v: '',
            other: false,
            other_name: '',
            other_version: ''
          },
          db: {
            v1: false,
            v2: false,
            v3: false,
            v4: false,
            otherText: '',
            des: ''
          }
        },
        quality: {
          situation_count: '',
          pic_x: '',
          pic_y: '',
          times: '',
          action_time: '',
          refresh: '',
          x: '',
          y: '',
          other: ''
        }
      }

    }
  },
  methods: {
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.infoFrameFileList = this.formInfo.frame_file ? JSON.parse(this.formInfo.frame_file) : []
        if (this.formInfo.frame_experiment_tech) {
          this.infoExperimentTech = JSON.parse(this.formInfo.frame_experiment_tech)
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.content-text {
  width: 100%;
  margin-bottom: 10px;
  word-break: break-all;
  h3 {
    font-size: 14px;
    color: inherit;
    margin: 5px 0;
    &:first-of-type {
      margin-top: 0;
    }
  }
  span {
    border-bottom: 1px solid #666;
    padding: 0px 0.5em;
    margin-left: 5px;
  }
}
#schemaPics {
  li {
    float: left;
    width: 100%;
    height: 100%;
    margin: 5px;
    overflow: hidden;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
